export default [
  {
    path: '/organizations',
    name: 'organizations.index',
    component: () => import('@/views/organizations/OrganizationsIndex.vue'),
    meta: {
      title: 'Organizations',
      requiresAuth: true,
      roles: ['vendor'] // Only vendors can access organizations
    }
  },
  {
    path: '/organizations/:id',
    name: 'organizations.show',
    component: () => import('@/views/organizations/OrganizationShow.vue'),
    meta: {
      title: 'Organization Details',
      requiresAuth: true,
      roles: ['vendor']
    }
  },
  {
    path: '/organizations/:id/edit',
    name: 'organizations.edit',
    component: () => import('@/views/organizations/OrganizationEdit.vue'),
    meta: {
      title: 'Edit Organization',
      requiresAuth: true,
      roles: ['vendor']
    }
  }
]